import { connect } from "react-redux";
import { withFormik } from "formik";
import { assetDetailSelector } from "selectors/asset";
import { defaultUnitsSelector, isOwnerSelector } from "selectors/currentUser";
import { isAssetDetail as isAssetDetailSelector } from "selectors/location";
import { selectedPortfolioSelector } from "selectors/portfolio";
import { getSpaces } from "selectors/space";

import ProposalForm from "./ProposalForm";

const form = withFormik({
  mapPropsToValues: ({ asset, isOwner, portfolio }) => ({
    asset,
    _brokers: [],
    offering: true,
    portfolio,
    shareStatus: isOwner ? "owner_team" : "broker_owner_team",
    spaces: [{}],
  }),
  handleSubmit: (values, { props: { onSubmit }, setSubmitting }) =>
    onSubmit(values).finally(() => setSubmitting(false)),
})(ProposalForm);

const mapStateToProps = (state) => {
  const asset = assetDetailSelector(state) || {};

  return {
    asset,
    currentUser: state.currentUser,
    defaultUnits: defaultUnitsSelector(state),
    portfolio: selectedPortfolioSelector(state) || (asset && asset.portfolio),
    isOwner: isOwnerSelector(state),
    isAssetDetail: isAssetDetailSelector(state),
    isSubmitting: state.loading.deal || state.loading.proposal,
    spaces: getSpaces(state),
  };
};

export default connect(mapStateToProps)(form);
